export function registerServiceWorker (url: string): void {
  if ('serviceWorker' in navigator) {
    try {
      navigator.serviceWorker.register(
        import.meta.env.MODE === 'production' ? url : '/dev-sw.js?dev-sw',
        { type: import.meta.env.MODE === 'production' ? 'classic' : 'module' },
      )
    } catch (error) {
      console.log('Service worker registration failed:', error)
    }
  }
}
